import styled from 'styled-components';
import { Button } from '../button/button.component.js';

const StyledGoogleButton = styled(Button) `
  border: 1px solid ${props => props.theme.colors.content.primary};
  background: ${props => props.theme.colors.background.primary};

  && {
    padding: 12px 16px;
  }

  p {
    margin: 0;
    margin-left: 8px;
    color: ${props => props.theme.colors.content.primary};
  }

  &:hover {
    background: #eeeeee;
  }

  &:focus {
    border: 1px solid ${props => props.theme.colors.content.primary};
    box-shadow: 0 0 0 2px ${props => props.theme.colors.content.primary};
    outline: transparent solid 2px;
  }
`;
const ContentWrapper = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 22px;
`;

export { ContentWrapper, StyledGoogleButton };
